import EventDetailsSummary from './EventDetailsSummary';

export default EventDetailsSummary;
